function trackStep(pairMode) {
  return pairMode ? 50 : 100;
}

function toTrackIndex(index, length, pairMode) {
  if (pairMode || length <= 1) return index;
  return index + 1;
}

function pairPeekTrackIndex(length) {
  return length;
}

function nextSlide(activeIndex, length, pairMode) {
  if (length <= 1) return { kind: 'idle' };

  const nextIndex = (activeIndex + 1) % length;
  if (pairMode) {
    if (nextIndex === 0) {
      return { kind: 'snap', activeIndex: 0, trackIndex: 0 };
    }
    return { kind: 'slide', activeIndex: nextIndex, trackIndex: nextIndex };
  }

  return {
    kind: 'slide',
    activeIndex: nextIndex,
    trackIndex: activeIndex === length - 1 ? length + 1 : toTrackIndex(nextIndex, length, false),
  };
}

function previousSlide(activeIndex, length, pairMode) {
  if (length <= 1) return { kind: 'idle' };

  if (pairMode) {
    if (activeIndex === 0) {
      const last = length - 1;
      return { kind: 'snap', activeIndex: last, trackIndex: last };
    }
    const previousIndex = activeIndex - 1;
    return { kind: 'slide', activeIndex: previousIndex, trackIndex: previousIndex };
  }

  const previousIndex = (activeIndex - 1 + length) % length;
  return {
    kind: 'slide',
    activeIndex: previousIndex,
    trackIndex: activeIndex === 0 ? 0 : toTrackIndex(previousIndex, length, false),
  };
}

function finishTrack(trackIndex, activeIndex, length, pairMode) {
  if (pairMode) {
    return { kind: 'align', trackIndex: activeIndex };
  }
  if (trackIndex === 0) {
    return { kind: 'snap', trackIndex: length };
  }
  if (trackIndex === length + 1) {
    return { kind: 'snap', trackIndex: 1 };
  }
  return { kind: 'align', trackIndex: toTrackIndex(activeIndex, length, false) };
}

module.exports = {
  trackStep,
  toTrackIndex,
  pairPeekTrackIndex,
  nextSlide,
  previousSlide,
  finishTrack,
};
